import { useState } from 'react';
import {
  AccionDetalle,
  IInitialState,
  TipoAccionDetalle,
} from '../../../Shared/data/FormReducer';
import { Tr4inerContainedButton, Tr4inerOutlinedButton } from '../../../Utils/Button';
import DialogConfirmarForm from '../../DialogConfirmarForm';

interface IController {
  state: IInitialState;
  dispatch: React.Dispatch<AccionDetalle>;
  handleNext: () => void;
  mostrarAdvertencia: boolean;
}

const Stepper: React.FC<IController> = (props) => {
  const [openNextDialog, setOpenNextDialog] = useState<boolean>(false);

  return (
    <div className="row flex mt-4">
      <div className="col-6 flex justify-content-end">
        <Tr4inerOutlinedButton
          variant="outlined"
          size="large"
          sx={{
            color: '#000',
            textTransform: 'capitalize',
            fontSize: '1.2rem',
            fontWeight: 'bold',
          }}
          onClick={() => {
            props.dispatch({
              type: TipoAccionDetalle.CHANGE_NFORM,
              payload: props.state.nForm - 1,
            });
            window.scrollTo({
              top: 0,
              behavior: 'smooth',
            });
          }}
        >
          {`Atrás`}
        </Tr4inerOutlinedButton>
      </div>
      <div className="col-6 flex justify-content-start">
        <Tr4inerContainedButton
          variant="contained"
          size="large"
          sx={{
            textTransform: 'capitalize',
            mr: 3,
            fontSize: '1.2rem',
            fontWeight: 'bold',
          }}
          onClick={() => {
            if (props.mostrarAdvertencia) setOpenNextDialog(true);
            else props.handleNext();
            window.scrollTo({
              top: 0,
              behavior: 'smooth',
            });
          }}
        >
          {`Siguiente`}
        </Tr4inerContainedButton>
      </div>

      {openNextDialog && props.mostrarAdvertencia && (
        <DialogConfirmarForm
          isOpen={openNextDialog}
          handleNext={props.handleNext}
          setIsOpen={setOpenNextDialog}
        />
      )}
    </div>
  );
};

export default Stepper;
